import { render } from "./PageWindowSwitcher.vue?vue&type=template&id=30419d8a"
import script from "./PageWindowSwitcher.vue?vue&type=script&lang=js"
export * from "./PageWindowSwitcher.vue?vue&type=script&lang=js"

import "./styles/PageWindowSwitcher.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__